/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { useNavigate } from "react-router-dom";
import { onClosePopUp, selectPoisBountyV3State } from "redux/slices";
import { Button, Container, Description, Title } from "./styles";
import { useEffect } from "react";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { getTimeLeft } from "utils/time";

interface PBV3CycleCompleteProps {}

export const PBV3CycleComplete = ({}: PBV3CycleCompleteProps) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { nowTime } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { tracker } = useAppSelector(selectPoisBountyV3State);
	const isPortrait = useMediaQuery(
		"(orientation: portrait) and (max-width: 899px)"
	);
	const scale = useCalculateScale(
		isPortrait ? 400 : 1050,
		isPortrait ? 600 : 400
	);
	const hasInfiniteCycles =
		tracker?.maxCycles === undefined && tracker?.cycleIndex !== undefined;
	const hasMoreCyclesToComplete =
		tracker?.cycleIndex !== undefined &&
		tracker?.maxCycles !== undefined &&
		tracker?.maxCycles !== null &&
		Number(tracker.cycleIndex) + 1 < Number(tracker.maxCycles);
	const showNextCycleMessage = hasInfiniteCycles || hasMoreCyclesToComplete;

	const continueShopping = () => {
		navigate("/shop");
		onClose();
	};
	const onClose = async () => {
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		if (tracker) {
			const timeLeft = getTimeLeft(nowTime, tracker?.endTime, "seconds");
			const timeTotal =
				getTimeLeft(tracker?.startTime, tracker?.endTime, "seconds") ||
				undefined;
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "event_restarted_pop_up",
				event_type: "pois_bounty_v3",
				action: "event_restarted_pop_up",
				source: "pois_bounty_v3",
				type: tracker?.eventType === "user" ? "personal" : tracker?.eventType,
				time_left: timeLeft,
				time_total: timeTotal,
				event_id: tracker?.eventId
			});
		}
	}, [tracker?.eventId]);

	return (
		<Container
			scale={scale}
			image={getImage(
				isPortrait
					? poisBountyAssets.v3.cycle.background
					: poisBountyAssets.v3.cycle.backgroundLandscape
			)}
		>
			<CloseIconButton onClose={onClose} />
			<div>
				<Title>
					{showNextCycleMessage ? (
						<>
							Completed!
							<br /> You’ve finished this cycle
						</>
					) : (
						<>
							Completed!
							<br /> You’ve finished the final cycle
						</>
					)}
				</Title>
				{!isPortrait && (
					<Description>
						{showNextCycleMessage ? (
							<>
								A new Poi’s Bounty cycle has started —
								<br /> keep going to earn more rewards!
							</>
						) : (
							<>
								You’ve completed all available Poi’s
								<br /> Bounty cycles. Collect your rewards and
								<br /> check back for future events.
							</>
						)}
					</Description>
				)}
			</div>
			<div>
				{isPortrait && (
					<Description>
						{showNextCycleMessage ? (
							<>
								A new Poi’s Bounty cycle has
								<br /> started — keep going to earn
								<br /> more rewards!
							</>
						) : (
							<>
								You’ve completed all available
								<br /> Poi’s Bounty cycles. Collect
								<br /> your rewards and check back
								<br /> for future events.
							</>
						)}
					</Description>
				)}
				<div>
					<Button themeColor="secondary" onClick={continueShopping}>
						Continue Shopping
					</Button>
				</div>
			</div>
		</Container>
	);
};
